import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.AccountUnitSize1,
  LocationVarKey.AccountUnitSize2,
  LocationVarKey.AfterNavigateAccountLoginUnitSize,
  LocationVarKey.AfterNavigateAccountLoginUnitSize1,
  LocationVarKey.AfterNavigateAccountLoginUnitSize2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Unit Size
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountUnitSize1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountUnitSize2}
        enableSwitchVar={LocationVarKey.AccountUnitSize2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginUnitSize}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginUnitSize, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginUnitSize, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginUnitSize, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginUnitSize1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginUnitSize, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginUnitSize2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginUnitSize2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
